import { Component, Host, Input, Output } from '@angular/core';
import { BllExpandPanelComponent } from './bll-expand-panel.component';
import { ENTER, hasModifierKey, SPACE } from '@angular/cdk/keycodes';

@Component({
  selector: 'bll-expand-panel-header',
  template: `<ng-content></ng-content>`,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  host: {
    class: 'expander-header',
    role: 'button',
    '[attr.id]': 'expand.headerId',
    '[attr.tabindex]': 'expand.disabled ? -1 : 0',
    '[attr.aria-disabled]': 'expand.disabled',
    '[attr.aria-controls]': 'expand.itemId',
    '[attr.aria-expanded]': 'expand.isOpen',
    '(click)': '_toggle()',
    '(keydown)': '_keydown($event)',
  },
})
export class BllExpandPanelHeaderComponent {
  constructor(@Host() public expand: BllExpandPanelComponent) {}

  _toggle(): void {
    this.expand.toggle();
  }

  _keydown(event: KeyboardEvent) {
    switch (event.keyCode) {
      // Toggle for space and enter keys.
      case SPACE:
      case ENTER:
        if (!hasModifierKey(event)) {
          event.preventDefault();
          this._toggle();
        }

        break;
      default:
        // if (this.panel.accordion) {
        //   this.panel.accordion._handleHeaderKeydown(event);
        // }
        return;
    }
  }
}
